import * as glassEasel from 'glass-easel';
/**
 * A backend context that has been associated to an environment
 */
export class AssociatedBackend {
    /** @internal */
    constructor(env, backendContext) {
        this._$env = env;
        this._$ = backendContext;
    }
    /**
     * Register a style sheet resource
     *
     * Some backend cannot load style sheet URL.
     * In this cases, the content should be registered here.
     */
    registerStyleSheetContent(url, content) {
        this._$.registerStyleSheetContent(url, content);
    }
    /**
     * Create a root component in specified backend
     *
     * The component is searched in the `codeSpace` with `url` .
     * If `url` contains "?" params, it will be parsed and try to set to component properties.
     */
    createRoot(tagName, codeSpace, url, genericTargets) {
        if (this._$env !== codeSpace._$env)
            throw new Error('The code space is not in the same environment as the backend');
        return new Root(this._$, tagName, codeSpace, url, genericTargets);
    }
}
/**
 * A root component
 */
export class Root {
    /** @internal */
    constructor(backendContext, tagName, codeSpace, url, genericTargets) {
        this._$comp = codeSpace
            .getComponentSpace()
            .createComponentByUrl(tagName, url, genericTargets || null, backendContext);
        if (codeSpace.isMainSpace()) {
            const globalStyleSheet = codeSpace.getStyleSheet('app');
            if (globalStyleSheet !== undefined) {
                const styleIsolation = codeSpace._$styleIsolationMap[this._$comp.is];
                if (styleIsolation === "isolated" /* StyleIsolation.Isolated */ ||
                    styleIsolation === "apply-shared" /* StyleIsolation.ApplyShared */ ||
                    styleIsolation === "shared" /* StyleIsolation.Shared */) {
                    backendContext.appendStyleSheetPath(globalStyleSheet, codeSpace._$sharedStyleScope);
                }
            }
        }
        const addStyleSheet = (comp) => {
            const { styleScope } = comp.getComponentOptions();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const codeSpace = comp.behavior.ownerSpace.__wxCodeSpace;
            const path = codeSpace === null || codeSpace === void 0 ? void 0 : codeSpace.getStyleSheet(comp.is);
            if (path !== undefined) {
                backendContext.appendStyleSheetPath(path, styleScope !== null && styleScope !== void 0 ? styleScope : glassEasel.StyleScopeManager.globalScope());
            }
        };
        this._$comp.getRootBehavior().getComponentDependencies().forEach(addStyleSheet);
        addStyleSheet(this._$comp.getComponentDefinition());
    }
    /**
     * Get the root component
     */
    get() {
        return this._$comp.getMethodCaller();
    }
    /**
     * Get the underlying component of the root component
     */
    getComponent() {
        return this._$comp;
    }
    /**
     * Attach the root component to the backend
     *
     * This component, the `parent` and the `placeholder` MUST be in the same context.
     * The `parent` MUST be a parent node of the `placeholder` .
     * This also triggers `attached` lifetimes for components.
     */
    attach(parent, placeholder) {
        glassEasel.Element.replaceDocumentElement(this._$comp, parent, placeholder);
    }
    /**
     * Release the root component
     *
     * Some backends require this explicit call to avoid memory leaks.
     * This also triggers `detached` lifetimes for components.
     */
    release() {
        glassEasel.Element.pretendDetached(this._$comp);
        this._$comp.destroyBackendElement();
    }
}
//# sourceMappingURL=backend.js.map